import {
  RadarChart, Radar, PolarGrid, PolarAngleAxis,
  PolarRadiusAxis, ResponsiveContainer, Tooltip,
} from 'recharts';
import { useTheme } from '../context/ThemeContext';

// Поля для радар-чарта (всё кроме веса и % жира)
const RADAR_FIELDS = [
  { key: 'chest_cm',      label: 'Грудь' },
  { key: 'bicep_cm',      label: 'Бицепс' },
  { key: 'waist_cm',      label: 'Талия' },
  { key: 'abdomen_cm',    label: 'Живот' },
  { key: 'hips_cm',       label: 'Бёдра' },
  { key: 'thigh_cm',      label: 'Бедро' },
  { key: 'above_knee_cm', label: 'Над коленом' },
  { key: 'calf_cm',       label: 'Голень' },
];

export default function BodyRadarChart({ current, previous }) {
  const { isDark } = useTheme();
  const gridColor  = isDark ? '#2D2540' : '#E8D9F0';
  const textColor  = isDark ? '#9E8CB8' : '#7B5FA0';

  if (!current) return null;

  const data = RADAR_FIELDS
    .filter(({ key }) => current[key] != null && parseFloat(current[key]) > 0)
    .map(({ key, label }) => ({
      label,
      current:  parseFloat(current[key]),
      previous: previous?.[key] ? parseFloat(previous[key]) : null,
    }));

  if (data.length < 3) return null;

  return (
    <div className="card p-4">
      <p className="section-label mb-1">Силуэт замеров</p>
      <div className="flex items-center gap-4 mb-3 text-xs text-ink-light-muted dark:text-ink-muted">
        <span className="flex items-center gap-1.5">
          <span className="w-3 h-0.5 bg-fuchsia inline-block rounded" />
          Текущий
        </span>
        {previous && (
          <span className="flex items-center gap-1.5">
            <span className="w-3 h-0.5 bg-surface-600 inline-block rounded border-dashed" />
            Предыдущий
          </span>
        )}
      </div>
      <ResponsiveContainer width="100%" height={260}>
        <RadarChart data={data} margin={{ top: 10, right: 25, left: 25, bottom: 10 }}>
          <PolarGrid stroke={gridColor} />
          <PolarAngleAxis dataKey="label" tick={{ fill: textColor, fontSize: 11 }} />
          <PolarRadiusAxis tick={false} axisLine={false} />
          {previous && (
            <Radar
              dataKey="previous"
              stroke="#9E8CB8"
              fill="#9E8CB8"
              fillOpacity={0.07}
              strokeWidth={1.5}
              strokeDasharray="4 2"
            />
          )}
          <Radar
            dataKey="current"
            stroke="#E8006F"
            fill="#E8006F"
            fillOpacity={0.15}
            strokeWidth={2}
          />
          <Tooltip
            formatter={(v, name) => [`${v} см`, name === 'current' ? 'Текущий' : 'Предыдущий']}
            contentStyle={{
              background: isDark ? '#1A1525' : '#fff',
              border: `1px solid ${isDark ? '#2D2540' : '#E8D9F0'}`,
              borderRadius: 12,
              fontSize: 12,
            }}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
